import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import reportWebVitals from "./reportWebVitals";

const IRIMC = React.lazy(() => import("./irimc"));
const Nowroz = React.lazy(() => import("./nowruz"));
const Mapna = React.lazy(() => import("./mapna"));
const Majles = React.lazy(() => import("./majles"));
const Amirzadergan = React.lazy(() => import("./amirzadegan"));
const ShahidBehestiUniversity = React.lazy(() => import("./beheshtiUniversity"));
const CyberspaceCenter = React.lazy(() => import("./cyberspaceCenter"));
const ISIC = React.lazy(() => import("./ISIC"));

const IrangardiSaleFestival = React.lazy(
  () => import("./irangardiSaleFestival")
);

localStorage.lang = "fa";

const screenType = process.env.REACT_APP_SCREEN_TYPE;

ReactDOM.render(
  <React.StrictMode>
    <Suspense fallback="">
      {screenType === "IRANGARDI_FESTIVAL" && <IrangardiSaleFestival />}
      {screenType === "IRIMC" && <IRIMC />}
      {screenType === "MAJLES" && <Majles />}
      {screenType === "NOWRUZ" && <Nowroz />}
      {screenType === "MAPNA" && <Mapna />}
      {screenType === "GENERAL" && <Amirzadergan />}
      {screenType === "SHAHID_BEHESHTI_UNIVERSITY" && <ShahidBehestiUniversity />}
      {screenType === "CYBERSPACE_CENTER" && <CyberspaceCenter />}
      {screenType === "ISIC" && <ISIC />}
    </Suspense>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
